// extracted by css-extract-rspack-plugin
export default {"Container":"UpdatedBy-module__Container__EJxAb","UserLink":"UpdatedBy-module__UserLink__DfNhT","GitHubAvatar":"UpdatedBy-module__GitHubAvatar___HLZN"};